export const signatures = {
  manageSignaturesTitle: 'Manage signatures',
  manageSignaturesPara:
    'Edit and manage the order of signatures in the configuration template',
  unassignedSignatures: 'Unassigned signatures',
  assignedSignatures: 'Created signature',
  updatedSignature: 'Signature updated',
  noUnassignedSignatures: 'No unassigned signatures',
  noAssignedSignature: 'No assigned signature',
}
